import * as React from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { SublistButton } from "./UnitList.styles";

interface IToggleSublistButtonProps {
  display: boolean;
  onClick: () => void;
}

export const ToggleSublistButton: React.SFC<IToggleSublistButtonProps> = ({ display, onClick }) => (
  <SublistButton onClick={onClick}>{display ? <FaChevronDown /> : <FaChevronRight />}</SublistButton>
);
